export class RataDTO{
    id?:string;
    data?:Date;
    paoId?:string;
    progressivo?:number;
    importoDaPagare?:number;
    importoPagato?:number;
    pagato:boolean = false;
    grAcquistati:number = 0;
    numeroFattura?:string;
    isLast:boolean = false;
    secondoFix:number = 0;
    gestione:number = 0;
    numerodeposito:string="";
    urlfattura:string="";
    updated_at?:Date;
    addrate: boolean = false;
    get importoUtile(){
        let importoPagato = this.importoPagato==undefined?0: this.importoPagato;
        let commissioni = (importoPagato)/(1+(this.gestione*0.01));
        commissioni=importoPagato-commissioni;
        if(importoPagato<=0)
            return 0;
        return importoPagato - commissioni;
    };
}